import { inject, Injectable, NgZone } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastTypeEnum } from '../../enums/toast-type/toast-type.enum';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    #messageService = inject(MessageService);
    #zone = inject(NgZone);

    success = this.#buildMethod(ToastTypeEnum.SUCCESS);
    info = this.#buildMethod(ToastTypeEnum.INFO);
    warn = this.#buildMethod(ToastTypeEnum.WARN);
    error = this.#buildMethod(ToastTypeEnum.ERROR);

    #buildMethod(severity: ToastTypeEnum) {
        return ({ title, message }: { title?: string; message: string }) => {
            this.#zone.run(() => {
                this.#messageService.add({
                    severity,
                    summary: title,
                    detail: message,
                    sticky: false,
                    life: 5000,
                });
            });
        };
    }
}
